var DataSet = require('@antv/data-set');
var sourceData = [{
  item: '事例一',
  count: 40
}, {
  item: '事例二',
  count: 21
}, {
  item: '事例三',
  count: 17
}, {
  item: '事例四',
  count: 13
}, {
  item: '事例五',
  count: 9
}];
var scale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}];
var dv = new DataSet.View().source(sourceData);
dv.transform({
  type: 'percent',
  field: 'count',
  dimension: 'item',
  as: 'percent'
});
var _data = dv.rows;
export default {
  name: 'SalesData',
  data: function data() {
    return {
      data: _data,
      scale: scale,
      height: 385,
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      },
      labelConfig: ['percent', {
        formatter: function formatter(val, item) {
          return item.point.item + ': ' + val;
        }
      }]
    };
  }
};